/**
 * GiftDrawer.js
 *
 * Slide-in drawer wrapper for GiveGiftForm.
 * Used for both direct gifts (/send) and gift pool contributions.
 */

import GiveGiftForm from './GiveGiftForm';

export default function GiftDrawer({ onClose, ...formProps }) {
  return (
    <div className="fixed inset-0 z-[200]">
      <style>{`
        @keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
        @keyframes fadeInBg { from { opacity: 0; } to { opacity: 1; } }
        .gift-drawer { animation: slideInRight 0.25s ease-out forwards; }
        .gift-drawer-bg { animation: fadeInBg 0.2s ease-out forwards; }
      `}</style>
      <div className="gift-drawer-bg fixed inset-0 bg-black/40 z-[200]" onClick={onClose} />
      <div className="gift-drawer fixed right-0 top-0 h-full w-full sm:w-[440px] bg-gray-50 shadow-2xl overflow-y-auto z-[201]">
        <GiveGiftForm onClose={onClose} {...formProps} />
      </div>
    </div>
  );
}
